var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87965 3.38672H8.26521C5.98204 3.38672 4.84046 3.38672 4.13117 4.08577C3.42188 4.78482 3.42188 5.90993 3.42188 8.16014V12.138C3.42188 14.3882 3.42188 15.5133 4.13117 16.2123C4.84046 16.9114 5.98204 16.9114 8.26521 16.9114H9.34939C10.0093 16.9114 10.3393 16.9114 10.6359 16.7903C10.9327 16.6692 11.166 16.4392 11.6326 15.9793L13.7772 13.8657C14.2439 13.4057 14.4772 13.1758 14.6001 12.8834C14.723 12.591 14.723 12.2658 14.723 11.6154V8.16014C14.723 5.90993 14.723 4.78482 14.0137 4.08577C13.3044 3.38672 12.1628 3.38672 9.87965 3.38672Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2832 16.5135V15.7179C10.2832 14.2178 10.2832 13.4677 10.7561 13.0017C11.2289 12.5356 11.99 12.5356 13.5121 12.5356H14.3193",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42167 14.5247C2.08422 14.5247 1 13.4562 1 12.138V5.77342C1 3.52321 1 2.3981 1.70929 1.69905C2.41858 1 3.56016 1 5.84333 1H9.87977C11.2172 1.00001 12.3014 2.0686 12.3014 3.38673",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24805 9.75113H9.47694M6.24805 6.56885H11.8986",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperWhite);
export default __webpack_public_path__ + "static/media/paper-white.880edd0b6211fe148cdc35161cd769cc.svg";
export { ForwardRef as ReactComponent };